import React, { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import Tippy from '@tippyjs/react';
import uniqBy from 'lodash/uniqBy';

import { ia, iaRa } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const NavigateToExternal = ({ data, node }) => {
  const ref = useRef();
  const [, setSearchParams] = useSearchParams();

  if (!!node?.group) return;

  const uniqueExternalInvoices = uniqBy(iaRa(data.external_invoice_ids), (invoiceId) =>
    Number(invoiceId)
  );

  if (!ia(uniqueExternalInvoices)) return null;

  const handleClick = (invoiceId) => {
    setSearchParams((prev) => {
      prev.set('type', 'external');
      prev.set('id', String(invoiceId));
      return prev;
    });
  };

  return (
    <div className="flex">
      <div ref={ref}>
        {ia(uniqueExternalInvoices) && (
          <Typography variant="p" size="small" color="primary-800">
            External: {uniqueExternalInvoices.length}
          </Typography>
        )}
      </div>
      <Tippy
        allowHTML
        interactive
        theme="light"
        reference={ref}
        placement="right"
        offset={[0, 10]}
        appendTo={() => document.body}
        content={
          <div className="flex flex-col gap-1 p-2">
            {ia(uniqueExternalInvoices) && (
              <>
                <Typography variant="p" size="small" color="primary-800" weight="medium">
                  External Invoices
                </Typography>
                {uniqueExternalInvoices?.map((invoiceId) => (
                  <Button
                    key={invoiceId}
                    text={String(invoiceId)}
                    onClick={() => handleClick(invoiceId)}
                    variant="link"
                    size="small"
                  />
                ))}
              </>
            )}
          </div>
        }
      />
    </div>
  );
};

export default NavigateToExternal;
